import { ConnectToForgeParameters } from '../render';

export function getConnectMacroId(parameters: ConnectToForgeParameters) {
	return parameters?.macroMetadata?.macroId?.value;
}
